import React from 'react';

type Props = { children: React.ReactNode };

export const GraphQLErrorMonitor: React.FC<Props> = ({ children }) => {
  // Server-error feedback now runs from Apollo's shared errorLink so
  // first-render queries are covered before any screen-level effects run.
  return <>{children}</>;
};
